const SESSION_KEY = 'ping.auth.session';
const SESSION_EVENT = 'ping:session-changed';

const isBrowser = typeof window !== 'undefined';

const emitSessionChange = (session) => {
  if (!isBrowser) {
    return;
  }

  window.dispatchEvent(new CustomEvent(SESSION_EVENT, { detail: session }));
};

export const getStoredSession = () => {
  if (!isBrowser) {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.warn('Failed to read stored session.', error);
    return null;
  }
};

export const storeSession = (session) => {
  if (!isBrowser) {
    return;
  }

  try {
    window.localStorage.setItem(SESSION_KEY, JSON.stringify(session));
    emitSessionChange(session);
  } catch (error) {
    console.warn('Failed to persist session.', error);
  }
};

export const clearStoredSession = () => {
  if (!isBrowser) {
    return;
  }

  try {
    window.localStorage.removeItem(SESSION_KEY);
  } catch (error) {
    console.warn('Failed to clear stored session.', error);
  } finally {
    emitSessionChange(null);
  }
};

export const subscribeToSessionChanges = (callback) => {
  if (!isBrowser) {
    return () => {};
  }

  const handler = (event) => callback(event.detail ?? null);
  window.addEventListener(SESSION_EVENT, handler);

  return () => {
    window.removeEventListener(SESSION_EVENT, handler);
  };
};
